// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared Organization UI — used by org-onboarding + org-admin + org-join */
:root {
  --org-border: #d1d5db;
  --org-border-soft: #e6e6e6;
  --org-surface: #ffffff;
  --org-surface-muted: #f7f8fa;
  --org-muted: #6b7280;
  --org-text: #1a1a1a;
  --org-control-height: 48px;
  --org-control-radius: 8px;
}

.org-page {
  max-width: 960px;
  margin: 24px auto;
  padding: 0 16px 40px;
  color: var(--org-text);
}

.skeleton-org-container {
  padding: 16px 0 8px;
}

.org-page__card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: var(--org-surface);
  color: inherit;
}

.org-page__card mat-card-header {
  margin-bottom: 8px;
}

.org-page__card mat-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--org-text);
}

.org-page__card mat-card-subtitle {
  color: #555;
}

.org-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 4px;
  align-items: center;
}

/* Bootstrap (3 via CDN + npm) gives every <label> a bottom margin and bold weight. */
.org-field,
.access-role-switch,
.feature-toggle {
  margin: 0;
  max-width: 100%;
  font-weight: inherit;
}

.org-field {
  display: grid;
  gap: 6px;
  width: 100%;
  min-width: 0;
  align-content: end;
}

.org-field__label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  color: #374151;
}

.org-input {
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--org-text);
  background: var(--org-surface);
  border: 1px solid var(--org-border);
  border-radius: var(--org-control-radius);
  padding: 12px 14px;
  margin: 0;
  min-height: var(--org-control-height);
  line-height: 1.4;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}
.org-input::placeholder {
  color: var(--org-muted);
  opacity: 1;
}
.org-input:focus {
  outline: none;
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
}
.org-input:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background: #f9fafb;
}

textarea.org-input {
  min-height: 96px;
  resize: vertical;
  padding-top: 12px;
  padding-bottom: 12px;
}

input[type=file].org-input {
  height: var(--org-control-height);
  min-height: var(--org-control-height);
  padding: 8px 12px;
  line-height: 30px;
  cursor: pointer;
}
input[type=file].org-input::file-selector-button {
  height: 30px;
  margin: 0 10px 0 0;
  padding: 0 12px;
  border: 1px solid var(--org-border);
  border-radius: 6px;
  background: var(--org-surface-muted);
  color: inherit;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  vertical-align: middle;
}

select.org-input,
input.org-input:not([type=file]) {
  height: var(--org-control-height);
}

select.org-input {
  -webkit-appearance: none;
          appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.org-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  font-family: inherit;
  white-space: nowrap;
  box-sizing: border-box;
  transition: all 0.2s ease;
  text-decoration: none;
  text-transform: none;
  letter-spacing: 0;
  min-height: var(--org-control-height);
  border-radius: var(--org-control-radius);
  font-size: 14px;
  font-weight: 500;
  padding: 12px 20px;
  line-height: 1.2;
}
.org-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.org-btn-primary {
  border: none;
  background: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: #fff;
}
.org-btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.org-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.org-btn-ghost {
  border: 1px solid #d1d5db;
  background: var(--org-surface-muted);
  color: #1f2937;
}
.org-btn-ghost:hover:not(:disabled) {
  background: #e8edf5;
  border-color: #c5cdd8;
}
.org-btn-ghost:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-text {
  border: 1px solid var(--org-primary, var(--fc-brand, #5ea1d8));
  background: transparent;
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
.org-btn-text:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.08);
}
.org-btn-text:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-dashed {
  width: auto;
  border: 1px dashed var(--org-primary, var(--fc-brand, #5ea1d8));
  background: var(--org-surface-muted);
  color: #1f2937;
}
.org-btn-dashed:hover:not(:disabled) {
  background: #e8edf5;
}
.org-btn-dashed:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-btn-dashed--block {
  width: 100%;
}

.org-btn-remove {
  border: none;
  background: transparent;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #c62828;
  min-height: auto;
  border-radius: 6px;
}
.org-btn-remove:hover:not(:disabled) {
  background: rgba(198, 40, 40, 0.08);
}

.org-btn-warn {
  border: none;
  background: #c62828;
  color: #fff;
}
.org-btn-warn:hover:not(:disabled) {
  background: #b71c1c;
}
.org-btn-warn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.manage-app,
.nested-card {
  border: 1px solid var(--org-border-soft);
  border-radius: 10px;
  padding: 14px;
  background: var(--org-surface-muted);
  display: grid;
  gap: 10px;
  color: var(--org-text);
}

.manage-app__header,
.manage-team__header,
.nested-card__title {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
}

.manage-app__title,
.manage-team__title,
.nested-card__title h3,
.nested-card__title h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--org-text);
}

.manage-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

/* Footer action bar for a form block: secondary first, primary last, right-aligned */
.org-form-actions {
  grid-column: 1/-1;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 4px;
}

.org-form-actions--split {
  justify-content: space-between;
}

.org-form-actions__group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.manage-app__header > .org-btn,
.manage-app__header .manage-actions .org-btn,
.manage-team__header .manage-actions .org-btn,
.nested-card__title > .org-btn {
  height: 36px;
  min-height: 36px;
  padding: 0 14px;
  font-size: 13px;
}

.org-section > .org-btn,
.org-form-panel > .org-btn,
.manage-app > .org-btn:not(.org-btn-dashed--block) {
  justify-self: start;
}

.manage-team,
.team-block {
  margin-left: 4px;
  padding: 10px 12px;
  border-left: 3px solid var(--org-accent, var(--fc-brand, #5ea1d8));
  background: #fff;
  border-radius: 0 8px 8px 0;
  display: grid;
  gap: 8px;
  color: var(--org-text);
}

.edit-grid,
.form-grid,
.terminology-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px 12px;
  align-items: end;
}

.edit-grid--inset {
  margin-top: 8px;
}

.edit-grid--grow {
  flex: 1;
  min-width: 0;
}

.invite-row {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-end;
  padding: 14px 16px;
  border: 1px solid var(--org-border-soft);
  border-radius: 12px;
  background: var(--org-surface);
  color: var(--org-text);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.invite-row .edit-grid {
  flex: 1;
  min-width: 0;
}

.invite-row > .org-btn {
  flex-shrink: 0;
}

.invite-list {
  display: grid;
  gap: 10px;
}

.invite-card {
  display: grid;
  gap: 12px;
  padding: 16px 18px;
  border: 1px solid var(--org-border-soft);
  border-radius: 14px;
  background: var(--org-surface);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
  color: var(--org-text);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.invite-card:hover {
  border-color: rgba(94, 161, 216, 0.45);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.invite-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.invite-card__identity {
  display: grid;
  gap: 6px;
  min-width: 0;
}

.invite-card__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
  color: var(--org-text);
  word-break: break-word;
}

.invite-card__subtitle {
  margin: 0;
  font-size: 0.85rem;
  color: var(--org-muted);
  line-height: 1.4;
}

.invite-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.invite-meta-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--org-surface-muted);
  border: 1px solid var(--org-border-soft);
  color: #374151;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.2;
}

.invite-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

.invite-card__body {
  display: grid;
  gap: 10px;
  padding-top: 4px;
  border-top: 1px solid var(--org-border-soft);
}

.invite-card--join .invite-card__body {
  margin-top: 2px;
}

.invite-card__footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 4px;
}

.org-form-panel {
  display: grid;
  gap: 14px;
  padding: 18px;
  border: 1px solid var(--org-border-soft);
  border-radius: 14px;
  background: linear-gradient(180deg, var(--org-surface) 0%, var(--org-surface-muted) 100%);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
}

.org-form-panel__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
}

.org-form-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

.org-form-panel__hint {
  margin: -6px 0 0;
  font-size: 0.85rem;
  color: var(--org-muted);
}

.org-section-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  margin-top: 8px;
}

.org-section-head h2 {
  margin: 0;
}

.org-section-head__count {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--org-muted);
}

/* Status badges — Pending / Requested / Accepted / Rejected */
.status-badge,
.pending-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.2;
  white-space: nowrap;
  border: 1px solid transparent;
  vertical-align: middle;
}

.status-badge mat-icon,
.pending-badge mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.status-badge--pending,
.pending-badge {
  background: rgba(242, 169, 0, 0.16);
  color: #8a5a00;
  border-color: rgba(242, 169, 0, 0.28);
  margin-left: 0;
}

.status-badge--requested {
  background: rgba(94, 161, 216, 0.14);
  color: #0b3d5c;
  border-color: rgba(94, 161, 216, 0.3);
}

.status-badge--accepted {
  background: rgba(22, 163, 74, 0.12);
  color: #166534;
  border-color: rgba(22, 163, 74, 0.28);
}

.status-badge--rejected {
  background: rgba(198, 40, 40, 0.1);
  color: #991b1b;
  border-color: rgba(198, 40, 40, 0.22);
}

.status-badge--incoming {
  background: rgba(124, 58, 237, 0.1);
  color: #5b21b6;
  border-color: rgba(124, 58, 237, 0.22);
}

.muted,
.hint {
  color: #555;
  font-size: 0.875rem;
  margin: 0;
}

.muted-empty {
  margin: 0;
  color: #777;
  font-size: 0.85rem;
  padding: 18px 16px;
  text-align: center;
  border: 1px dashed var(--org-border-soft);
  border-radius: 12px;
  background: var(--org-surface-muted);
}

.term-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.term-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 10px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.18);
  color: #1a5278;
  font-size: 0.85rem;
  font-weight: 600;
}

.term-chip__remove {
  border: none;
  background: transparent;
  padding: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: inherit;
  font-size: 16px;
  line-height: 1;
}

.term-add-row,
.org-inline-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: end;
}

.term-add-row .org-btn,
.org-inline-row .org-btn {
  align-self: end;
}

.library-access-panel {
  display: grid;
  gap: 6px;
}

.empty-state {
  text-align: center;
  padding: 40px 16px;
  color: #555;
  display: grid;
  gap: 12px;
  justify-items: center;
}

.empty-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--fc-brand, #5ea1d8);
}

.org-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 16px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--org-border-soft);
}

.org-tab {
  border: 1px solid transparent;
  background: transparent;
  border-radius: 999px;
  padding: 8px 14px;
  font: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
}
.org-tab:hover {
  background: #f5f5f5;
}
.org-tab.active {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: rgba(94, 161, 216, 0.12);
  color: #0b3d5c;
}
.org-tab .status-badge,
.org-tab .pending-badge {
  margin-left: 6px;
}

.org-section {
  display: grid;
  gap: 12px;
}

.org-section h2 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--org-text);
}

.editing-banner {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: rgba(94, 161, 216, 0.12);
  color: #1a5278;
  font-size: 0.9rem;
}

/* Access roles — shared by onboarding + admin */
.access-role-list {
  display: grid;
  gap: 12px;
}

.access-role-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.access-role-card--off {
  opacity: 0.72;
  background: #fafafa;
}

.access-role-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  background: #f8fafc;
}

.access-role-card__toggle-expand {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  color: var(--org-text);
  padding: 0;
}

.access-role-card__key {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.9rem;
}

.access-role-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: #334155;
  -webkit-user-select: none;
          user-select: none;
}

.access-role-switch input,
.feature-toggle input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
  flex-shrink: 0;
}

.feature-toggle input[type=checkbox] {
  margin-top: 2px;
}

.access-role-switch.locked {
  opacity: 0.85;
}

.access-role-card__body {
  display: grid;
  gap: 10px;
  padding: 12px;
}

.access-role-features-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.feature-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.15);
  color: #0b3d5c;
  font-size: 0.75rem;
  font-weight: 600;
}

.access-role-features__title {
  margin: 4px 0 0;
  font-size: 0.9rem;
  font-weight: 600;
}

.feature-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-top: 1px solid #f0f0f0;
  cursor: pointer;
}

.feature-toggle__text {
  display: grid;
  gap: 2px;
}

.feature-toggle__text strong {
  font-size: 0.9rem;
}

.feature-toggle__text small {
  color: #64748b;
  font-size: 0.8rem;
}

@media (max-width: 640px) {
  .org-page {
    margin-top: 12px;
    padding: 0 12px 32px;
  }
  .invite-row,
  .invite-card,
  .manage-app__header,
  .manage-team__header,
  .nested-card__title {
    flex-direction: column;
    align-items: stretch;
  }
  .invite-card__top,
  .invite-card__footer,
  .invite-card__actions {
    flex-direction: column;
    align-items: stretch;
  }
  .invite-card__actions .org-btn,
  .invite-card__footer .org-btn {
    width: 100%;
  }
  .term-add-row,
  .org-inline-row {
    grid-template-columns: 1fr;
  }
  .term-add-row .org-btn,
  .org-inline-row .org-btn {
    width: 100%;
  }
  .manage-actions .org-btn,
  .org-form-actions .org-btn,
  .org-form-panel__actions .org-btn {
    flex: 1 1 auto;
  }
  .org-form-actions,
  .org-form-actions__group {
    width: 100%;
  }
  .invite-row .org-btn {
    width: 100%;
  }
}
:host-context(body.theme-dark) .org-page {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-page__card {
  background: #1e293b;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-page__card mat-card-title,
:host-context(body.theme-dark) .org-section h2,
:host-context(body.theme-dark) .manage-app__title,
:host-context(body.theme-dark) .manage-team__title,
:host-context(body.theme-dark) .nested-card__title h3,
:host-context(body.theme-dark) .nested-card__title h4 {
  color: #f8fafc;
}
:host-context(body.theme-dark) .org-page__card mat-card-subtitle,
:host-context(body.theme-dark) .muted,
:host-context(body.theme-dark) .hint,
:host-context(body.theme-dark) .muted-empty,
:host-context(body.theme-dark) .empty-state {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-field__label {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .org-input {
  color: #f8fafc;
  background: #0f172a;
  border-color: #475569;
}
:host-context(body.theme-dark) .org-input::placeholder {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-input:focus {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);
}
:host-context(body.theme-dark) .org-input:disabled {
  background: #1e293b;
}
:host-context(body.theme-dark) .org-btn-ghost {
  border-color: #334155;
  background: #0f172a;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-btn-ghost:hover:not(:disabled) {
  background: #334155;
}
:host-context(body.theme-dark) .org-btn-text {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: #7eb8e8;
}
:host-context(body.theme-dark) .org-btn-text:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.15);
}
:host-context(body.theme-dark) .org-btn-dashed {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: #0f172a;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-btn-dashed:hover:not(:disabled) {
  background: #1e293b;
}
:host-context(body.theme-dark) .org-btn-remove {
  color: #f87171;
}
:host-context(body.theme-dark) .org-btn-remove:hover:not(:disabled) {
  background: rgba(248, 113, 113, 0.12);
}
:host-context(body.theme-dark) .manage-app,
:host-context(body.theme-dark) .nested-card,
:host-context(body.theme-dark) .invite-row,
:host-context(body.theme-dark) .invite-card,
:host-context(body.theme-dark) .org-form-panel {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .invite-card:hover {
  border-color: rgba(94, 161, 216, 0.5);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}
:host-context(body.theme-dark) .invite-card__title {
  color: #f8fafc;
}
:host-context(body.theme-dark) .invite-card__subtitle,
:host-context(body.theme-dark) .org-form-panel__hint,
:host-context(body.theme-dark) .org-section-head__count {
  color: #94a3b8;
}
:host-context(body.theme-dark) .invite-card__body {
  border-top-color: #334155;
}
:host-context(body.theme-dark) .invite-meta-chip {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
:host-context(body.theme-dark) .muted-empty {
  background: #0f172a;
  border-color: #334155;
  color: #94a3b8;
}
:host-context(body.theme-dark) .manage-team,
:host-context(body.theme-dark) .team-block {
  background: #1e293b;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .org-tabs {
  border-bottom-color: #334155;
}
:host-context(body.theme-dark) .org-tab {
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-tab:hover {
  background: #0f172a;
}
:host-context(body.theme-dark) .org-tab.active {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: rgba(94, 161, 216, 0.2);
  color: #e0f2fe;
}
:host-context(body.theme-dark) .pending-badge,
:host-context(body.theme-dark) .status-badge--pending {
  background: rgba(242, 169, 0, 0.25);
  color: #fbbf24;
  border-color: rgba(242, 169, 0, 0.35);
}
:host-context(body.theme-dark) .status-badge--requested {
  background: rgba(94, 161, 216, 0.22);
  color: #7dd3fc;
  border-color: rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .status-badge--accepted {
  background: rgba(34, 197, 94, 0.18);
  color: #86efac;
  border-color: rgba(34, 197, 94, 0.3);
}
:host-context(body.theme-dark) .status-badge--rejected {
  background: rgba(248, 113, 113, 0.15);
  color: #fca5a5;
  border-color: rgba(248, 113, 113, 0.28);
}
:host-context(body.theme-dark) .status-badge--incoming {
  background: rgba(167, 139, 250, 0.18);
  color: #c4b5fd;
  border-color: rgba(167, 139, 250, 0.3);
}
:host-context(body.theme-dark) .term-chip {
  background: rgba(94, 161, 216, 0.25);
  color: #bae6fd;
}
:host-context(body.theme-dark) .editing-banner {
  background: rgba(94, 161, 216, 0.2);
  color: #bae6fd;
}
:host-context(body.theme-dark) .empty-state mat-icon {
  color: var(--fc-brand, #5ea1d8);
}
:host-context(body.theme-dark) .access-role-card {
  background: #0f172a;
  border-color: #334155;
}
:host-context(body.theme-dark) .access-role-card--off {
  background: #0b1220;
}
:host-context(body.theme-dark) .access-role-card__header {
  background: #111827;
  border-color: #334155;
}
:host-context(body.theme-dark) .access-role-card__toggle-expand,
:host-context(body.theme-dark) .access-role-switch,
:host-context(body.theme-dark) .access-role-features__title {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .feature-chip {
  background: rgba(94, 161, 216, 0.22);
  color: #bae6fd;
}
:host-context(body.theme-dark) .feature-toggle {
  border-color: #1e293b;
}
:host-context(body.theme-dark) .feature-toggle__text small {
  color: #94a3b8;
}

/* Section tabs: one scrollable line with prev/next arrows, matching the org setup wizard */
.org-tabs-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 16px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--org-border-soft, #e6e6e6);
}

.org-tabs-arrow {
  flex: 0 0 auto;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}
.org-tabs-arrow mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  line-height: 22px;
}
.org-tabs-arrow:hover:not(:disabled) {
  border-color: var(--org-primary, var(--fc-brand, #5ea1d8));
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}
.org-tabs-arrow:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.org-tabs-nav .org-tabs {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 4px 2px;
  border-bottom: none;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  touch-action: pan-x;
}
.org-tabs-nav .org-tabs::-webkit-scrollbar {
  display: none;
}

.org-tabs-nav .org-tab {
  flex: 0 0 auto;
  border: none;
  background: transparent;
  padding: 0;
  min-height: 0;
  color: #9ca3af;
  white-space: nowrap;
  touch-action: pan-x;
}
.org-tabs-nav .org-tab:hover {
  background: transparent;
  color: #6b7280;
}
.org-tabs-nav .org-tab .org-tab__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  line-height: 1.2;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 7px 14px;
  border-radius: 35px;
  border: 2px solid currentColor;
}
.org-tabs-nav .org-tab .status-badge {
  margin-left: 0;
  text-transform: none;
  letter-spacing: 0;
}
.org-tabs-nav .org-tab.active {
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: transparent;
}
.org-tabs-nav .org-tab.active .org-tab__label {
  background: rgba(94, 161, 216, 0.1);
}

.org-header-actions .org-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

@media (max-width: 640px) {
  /* Primary action on its own row; secondary actions share the row below. */
  .org-header-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 4px 0 8px;
  }
  .org-header-actions .org-btn {
    width: 100%;
    min-height: 44px;
    padding: 8px 10px;
    font-size: 14px;
    white-space: normal;
    text-align: center;
    line-height: 1.2;
  }
  .org-header-actions .org-btn-primary,
  .org-header-actions a.org-btn:only-of-type {
    grid-column: 1/-1;
  }
  .org-tabs-nav {
    gap: 4px;
  }
  .org-tabs-arrow {
    width: 28px;
    height: 28px;
  }
  .org-tabs-nav .org-tab .org-tab__label {
    font-size: 11px;
    letter-spacing: 0.02em;
    padding: 6px 12px;
  }
}
.org-selector {
  margin: 12px 0 4px;
}

.owned-list {
  display: grid;
  gap: 8px;
}

.owned-item {
  padding: 10px 12px;
  background: #f7f8fa;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  color: #1a1a1a;
}

.library-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.library-card {
  display: grid;
  gap: 8px;
  text-align: left;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #fff;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  font: inherit;
  color: #1a1a1a;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.library-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.library-card__thumb {
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef5fb, #f7faf8);
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
  overflow: hidden;
  position: relative;
}

.library-card__cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.library-card__thumb mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
}

.library-card__body {
  padding: 10px 12px 14px;
  display: grid;
  gap: 4px;
}

.library-card__type {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--org-accent, var(--fc-brand, #5ea1d8));
}

.library-card__uid {
  font-size: 0.75rem;
  font-weight: 600;
  color: #1d67a3;
  background: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
  justify-self: start;
  letter-spacing: 0.02em;
}

.feedback-card {
  padding: 12px 14px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #fff;
  color: #1a1a1a;
  display: grid;
  gap: 6px;
}

.feedback-card__top {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.issue-chip {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.15);
  color: #1a5278;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
}

.access-role-list {
  margin-bottom: 16px;
}

.audit-section {
  min-width: 0;
  max-width: 100%;
}

.audit-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 16px;
  min-width: 0;
}

.audit-filters {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
  max-width: 100%;
}
.audit-filters::-webkit-scrollbar {
  display: none;
}

.audit-filter {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid #d0d7de;
  background: transparent;
  color: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.audit-filter mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.audit-filter .count {
  min-width: 18px;
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(94, 161, 216, 0.12);
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
.audit-filter:hover {
  border-color: var(--fc-brand, #5ea1d8);
}
.audit-filter.active {
  background: var(--fc-brand, #5ea1d8);
  border-color: var(--fc-brand, #5ea1d8);
  color: #fff;
}
.audit-filter.active .count {
  background: rgba(255, 255, 255, 0.25);
}

.audit-search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 280px;
  min-width: 0;
  max-width: 460px;
}
.audit-search > mat-icon {
  color: #667085;
}
.audit-search input {
  flex: 1 1 auto;
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  font-size: 14px;
}
.audit-search input:focus {
  outline: none;
  border-color: var(--fc-brand, #5ea1d8);
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}
.audit-search .org-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 40px;
  min-height: 40px;
  padding: 0 14px;
  flex-shrink: 0;
}
.audit-search .org-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.audit-state {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px 0;
  color: #667085;
}

@media (max-width: 600px) {
  .audit-filters {
    flex-basis: 100%;
  }
  .audit-search {
    flex-basis: 100%;
    max-width: none;
  }
}
.members-panel__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.members-panel__count {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 0.75rem;
  background: #eef5fb;
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
  vertical-align: middle;
}

.members-search {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1 260px;
  max-width: 360px;
}
.members-search > mat-icon {
  color: #667085;
  flex-shrink: 0;
}
.members-search input {
  flex: 1;
  min-width: 0;
  height: 40px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d9dee5;
  border-radius: 8px;
  font: inherit;
}
.members-search .org-btn {
  height: 40px;
  min-height: 40px;
  width: 40px;
  padding: 0;
  flex-shrink: 0;
}

.members-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  color: #8a5300;
  font-size: 0.875rem;
}

.members-table {
  display: grid;
  gap: 8px;
}

.members-row {
  display: grid;
  grid-template-columns: minmax(180px, 1.2fr) minmax(160px, 1fr) minmax(240px, 1.4fr);
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #fff;
}

.members-row--unassigned {
  border-color: #ffd591;
  background: #fffbf2;
}

.members-row__who {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.members-row__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.members-row__avatar-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #9aa5b1;
}

.members-row__text {
  display: grid;
  min-width: 0;
}
.members-row__text strong,
.members-row__text span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.members-row__scope {
  display: grid;
  gap: 4px;
  justify-items: start;
}

.role-chip {
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: #eef5fb;
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
}

.role-chip--none {
  background: #fff1e0;
  color: #b45309;
}

.members-row__edit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.members-row__edit .org-input {
  flex: 1 1 140px;
  min-width: 120px;
  height: 40px;
  min-height: 40px;
  padding-top: 0;
  padding-bottom: 0;
}
.members-row__edit .org-btn {
  height: 40px;
  min-height: 40px;
  padding: 0 16px;
}

.members-pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}

@media (max-width: 860px) {
  .members-row {
    grid-template-columns: 1fr;
  }
}
.invite-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.55);
}

.invite-dialog {
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  margin: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);
}

:host-context(body.theme-dark) .org-tabs-nav {
  border-bottom-color: #334155;
}
:host-context(body.theme-dark) .org-tabs-arrow {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .org-tabs-nav .org-tab {
  color: #64748b;
}
:host-context(body.theme-dark) .org-tabs-nav .org-tab:hover {
  background: transparent;
  color: #94a3b8;
}
:host-context(body.theme-dark) .org-tabs-nav .org-tab.active {
  color: var(--org-primary, var(--fc-brand, #5ea1d8));
  background: transparent;
}
:host-context(body.theme-dark) .org-tabs-nav .org-tab.active .org-tab__label {
  background: rgba(94, 161, 216, 0.15);
}
:host-context(body.theme-dark) .invite-dialog {
  background: #0f172a;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .owned-item {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .library-card,
:host-context(body.theme-dark) .feedback-card {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .library-card__thumb {
  background: linear-gradient(135deg, #1e3a5f, #0f172a);
}
:host-context(body.theme-dark) .issue-chip {
  background: rgba(94, 161, 216, 0.25);
  color: #bae6fd;
}
:host-context(body.theme-dark) .audit-filter {
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .audit-search input,
:host-context(body.theme-dark) .members-search input {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .members-row {
  background: #0f172a;
  border-color: #334155;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .members-row--unassigned {
  background: rgba(245, 158, 11, 0.08);
  border-color: rgba(245, 158, 11, 0.45);
}
:host-context(body.theme-dark) .members-alert {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.45);
  color: #fcd34d;
}
:host-context(body.theme-dark) .role-chip,
:host-context(body.theme-dark) .members-panel__count {
  background: rgba(94, 161, 216, 0.25);
  color: #bae6fd;
}
:host-context(body.theme-dark) .role-chip--none {
  background: rgba(245, 158, 11, 0.2);
  color: #fcd34d;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/org-admin/org-admin.component.scss","webpack://./src/app/shared/styles/org-ui.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,2EAAA;AAEA;EACE,qBAAA;EACA,0BAAA;EACA,sBAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;EACA,0BAAA;EACA,yBAAA;ADCF;;ACEA;EACE,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;ADCF;;ACEA;EACE,mBAAA;ADCF;;ACEA;EACE,mBAAA;EACA,0CAAA;EACA,8BAAA;EACA,cAAA;ADCF;;ACEA;EACE,kBAAA;ADCF;;ACEA;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;ADCF;;ACEA;EACE,WAAA;ADCF;;ACEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;ADCF;;ACEA,qFAAA;AACA;;;EAGE,SAAA;EACA,eAAA;EACA,oBAAA;ADCF;;ACEA;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ADCF;;ACEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ADCF;;ACEA;EACE,WAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,SAAA;EACA,qCAAA;EACA,gBAAA;EACA,0DAAA;EACA,sBAAA;ADCF;ACCE;EACE,uBAAA;EACA,UAAA;ADCJ;ACEE;EACE,aAAA;EACA,0DAAA;EACA,8CAAA;ADAJ;ACGE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;ADDJ;;ACKA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;ADFF;;ACKA;EACE,iCAAA;EACA,qCAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;ADFF;ACIE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;ADFJ;;ACMA;;EAEE,iCAAA;ADHF;;ACMA;EACE,wBAAA;UAAA,gBAAA;EACA,wLAAA;EACA,4BAAA;EACA,sCAAA;EACA,mBAAA;ADHF;;ACMA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qCAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ADHF;ACKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;ADHJ;;ACOA;EACE,YAAA;EACA,wDAAA;EACA,WAAA;ADJF;ACME;EACE,mBAAA;ADJJ;ACOE;EACE,YAAA;EACA,mBAAA;ADLJ;;ACSA;EACE,yBAAA;EACA,oCAAA;EACA,cAAA;ADNF;ACQE;EACE,mBAAA;EACA,qBAAA;ADNJ;ACSE;EACE,aAAA;EACA,mBAAA;ADPJ;;ACWA;EACE,8DAAA;EACA,uBAAA;EACA,mDAAA;ADRF;ACUE;EACE,oCAAA;ADRJ;ACWE;EACE,aAAA;EACA,mBAAA;ADTJ;;ACaA;EACE,WAAA;EACA,+DAAA;EACA,oCAAA;EACA,cAAA;ADVF;ACYE;EACE,mBAAA;ADVJ;ACaE;EACE,aAAA;EACA,mBAAA;ADXJ;;ACeA;EACE,WAAA;ADZF;;ACeA;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ADZF;ACcE;EACE,mCAAA;ADZJ;;ACgBA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;ADbF;ACeE;EACE,mBAAA;ADbJ;ACgBE;EACE,YAAA;EACA,mBAAA;ADdJ;;ACkBA;;EAEE,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;ADfF;;ACkBA;;;EAGE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;ADfF;;ACkBA;;;;EAIE,SAAA;EACA,eAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA,qFAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ADfF;;ACkBA;EACE,8BAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA;;;;EAIE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;ADfF;;ACkBA;;;EAGE,mBAAA;ADfF;;ACkBA;;EAEE,gBAAA;EACA,kBAAA;EACA,kEAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;ADfF;;ACkBA;;;EAGE,aAAA;EACA,2DAAA;EACA,cAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,eAAA;ADfF;;ACkBA;EACE,OAAA;EACA,YAAA;ADfF;;ACkBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,4CAAA;ADfF;;ACkBA;EACE,OAAA;EACA,YAAA;ADfF;;ACkBA;EACE,cAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,mBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sBAAA;EACA,0DAAA;ADfF;;ACkBA;EACE,sCAAA;EACA,6CAAA;ADfF;;ACkBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;ADfF;;ACkBA;EACE,aAAA;EACA,QAAA;EACA,YAAA;ADfF;;ACkBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;ADfF;;ACkBA;EACE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;ADfF;;ACkBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,oCAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,4CAAA;ADfF;;ACkBA;EACE,eAAA;ADfF;;ACkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,yBAAA;EACA,gBAAA;ADfF;;ACkBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,yFAAA;EAKA,4CAAA;ADnBF;;ACsBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;ADnBF;;ACsBA;EACE,gBAAA;EACA,kBAAA;EACA,uBAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;ADnBF;;ACsBA;EACE,SAAA;ADnBF;;ACsBA;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;ADnBF;;ACsBA,8DAAA;AACA;;EAEE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;ADnBF;;ACsBA;;EAEE,eAAA;EACA,WAAA;EACA,YAAA;ADnBF;;ACsBA;;EAEE,mCAAA;EACA,cAAA;EACA,qCAAA;EACA,cAAA;ADnBF;;ACsBA;EACE,oCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,mCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,kCAAA;EACA,cAAA;EACA,qCAAA;ADnBF;;ACsBA;EACE,mCAAA;EACA,cAAA;EACA,sCAAA;ADnBF;;ACsBA;;EAEE,WAAA;EACA,mBAAA;EACA,SAAA;ADnBF;;ACsBA;EACE,SAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EACA,oCAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;ADnBF;;ACsBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ADnBF;;ACsBA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;ADnBF;;ACsBA;;EAEE,aAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;ADnBF;;ACsBA;;EAEE,eAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,QAAA;ADnBF;;ACsBA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,qBAAA;ADnBF;;ACsBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;ADnBF;;ACsBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,+CAAA;ADnBF;;ACsBA;EACE,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;ADnBF;ACqBE;EACE,mBAAA;ADnBJ;ACsBE;EACE,0DAAA;EACA,oCAAA;EACA,cAAA;ADpBJ;ACuBE;;EAEE,gBAAA;ADrBJ;;ACyBA;EACE,aAAA;EACA,SAAA;ADtBF;;ACyBA;EACE,SAAA;EACA,iBAAA;EACA,sBAAA;ADtBF;;ACyBA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;ADtBF;;ACyBA,gDAAA;AACA;EACE,aAAA;EACA,SAAA;ADtBF;;ACyBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,mBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,UAAA;ADtBF;;ACyBA;EACE,qEAAA;EACA,iBAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;ADtBF;;ACyBA;;EAEE,WAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;ADtBF;;ACyBA;EACE,eAAA;ADtBF;;ACyBA;EACE,aAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,SAAA;EACA,aAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;ADtBF;;ACyBA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;ADtBF;;ACyBA;EACE,aAAA;EACA,QAAA;ADtBF;;ACyBA;EACE,iBAAA;ADtBF;;ACyBA;EACE,cAAA;EACA,iBAAA;ADtBF;;ACyBA;EACE;IACE,gBAAA;IACA,oBAAA;EDtBF;ECyBA;;;;;IAKE,sBAAA;IACA,oBAAA;EDvBF;EC0BA;;;IAGE,sBAAA;IACA,oBAAA;EDxBF;EC2BA;;IAEE,WAAA;EDzBF;EC4BA;;IAEE,0BAAA;ED1BF;EC6BA;;IAEE,WAAA;ED3BF;EC8BA;;;IAGE,cAAA;ED5BF;EC+BA;;IAEE,WAAA;ED7BF;ECgCA;IACE,WAAA;ED9BF;AACF;ACkCE;EACE,cAAA;ADhCJ;ACmCE;EACE,mBAAA;EACA,0CAAA;EACA,cAAA;ADjCJ;ACoCE;;;;;;EAME,cAAA;ADlCJ;ACqCE;;;;;EAKE,cAAA;ADnCJ;ACsCE;EACE,cAAA;ADpCJ;ACuCE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;ADrCJ;ACuCI;EACE,cAAA;ADrCN;ACwCI;EACE,0DAAA;EACA,8CAAA;ADtCN;ACyCI;EACE,mBAAA;ADvCN;AC2CE;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;ADzCJ;AC2CI;EACE,mBAAA;ADzCN;AC6CE;EACE,0DAAA;EACA,cAAA;AD3CJ;AC6CI;EACE,oCAAA;AD3CN;AC+CE;EACE,0DAAA;EACA,mBAAA;EACA,cAAA;AD7CJ;AC+CI;EACE,mBAAA;AD7CN;ACiDE;EACE,cAAA;AD/CJ;ACiDI;EACE,qCAAA;AD/CN;ACmDE;;;;;EAKE,mBAAA;EACA,qBAAA;EACA,cAAA;ADjDJ;ACoDE;EACE,qCAAA;EACA,0CAAA;ADlDJ;ACqDE;EACE,cAAA;ADnDJ;ACsDE;;;EAGE,cAAA;ADpDJ;ACuDE;EACE,yBAAA;ADrDJ;ACwDE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ADtDJ;ACyDE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ADvDJ;AC0DE;;EAEE,mBAAA;EACA,cAAA;ADxDJ;AC2DE;EACE,4BAAA;ADzDJ;AC4DE;EACE,cAAA;AD1DJ;AC4DI;EACE,mBAAA;AD1DN;AC6DI;EACE,0DAAA;EACA,mCAAA;EACA,cAAA;AD3DN;AC+DE;;EAEE,mCAAA;EACA,cAAA;EACA,qCAAA;AD7DJ;ACgEE;EACE,oCAAA;EACA,cAAA;EACA,sCAAA;AD9DJ;ACiEE;EACE,mCAAA;EACA,cAAA;EACA,oCAAA;AD/DJ;ACkEE;EACE,qCAAA;EACA,cAAA;EACA,uCAAA;ADhEJ;ACmEE;EACE,qCAAA;EACA,cAAA;EACA,sCAAA;ADjEJ;ACoEE;EACE,oCAAA;EACA,cAAA;ADlEJ;ACqEE;EACE,mCAAA;EACA,cAAA;ADnEJ;ACsEE;EACE,+BAAA;ADpEJ;ACuEE;EACE,mBAAA;EACA,qBAAA;ADrEJ;ACwEE;EACE,mBAAA;ADtEJ;ACyEE;EACE,mBAAA;EACA,qBAAA;ADvEJ;AC0EE;;;EAGE,cAAA;ADxEJ;AC2EE;EACE,oCAAA;EACA,cAAA;ADzEJ;AC4EE;EACE,qBAAA;AD1EJ;AC6EE;EACE,cAAA;AD3EJ;;AA7jCA,2FAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,wDAAA;AAgkCF;;AA7jCA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qDAAA;AAgkCF;AA9jCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAgkCJ;AA7jCE;EACE,0DAAA;EACA,mDAAA;AA+jCJ;AA5jCE;EACE,aAAA;EACA,mBAAA;AA8jCJ;;AA1jCA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;AA6jCF;AA3jCE;EACE,aAAA;AA6jCJ;;AAzjCA;EACE,cAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AA4jCF;AA1jCE;EACE,uBAAA;EACA,cAAA;AA4jCJ;AAzjCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AA2jCJ;AAxjCE;EACE,cAAA;EACA,oBAAA;EACA,iBAAA;AA0jCJ;AAvjCE;EACE,mDAAA;EACA,uBAAA;AAyjCJ;AAvjCI;EACE,mCAAA;AAyjCN;;AApjCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAujCF;;AApjCA;EACE,0EAAA;EACA;IACE,aAAA;IACA,gDAAA;IACA,QAAA;IACA,iBAAA;EAujCF;EArjCE;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;EAujCJ;EApjCE;;IAEE,iBAAA;EAsjCJ;EAljCA;IACE,QAAA;EAojCF;EAjjCA;IACE,WAAA;IACA,YAAA;EAmjCF;EAhjCA;IACE,eAAA;IACA,sBAAA;IACA,iBAAA;EAkjCF;AACF;AA/iCA;EACE,kBAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,QAAA;AAijCF;;AA9iCA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,uDAAA;AAijCF;;AA9iCA;EACE,0CAAA;EACA,2BAAA;AAijCF;;AA9iCA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;EACA,mDAAA;EACA,gBAAA;EACA,kBAAA;AAijCF;;AA9iCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAijCF;;AA9iCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAijCF;;AA9iCA;EACE,uBAAA;EACA,aAAA;EACA,QAAA;AAijCF;;AA9iCA;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kDAAA;AAijCF;;AA9iCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAijCF;;AA9iCA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAijCF;;AA9iCA;EACE,oBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAijCF;;AA9iCA;EACE,mBAAA;AAijCF;;AA9iCA;EACE,YAAA;EACA,eAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;AAijCF;;AA9iCA;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AAijCF;AA/iCE;EACE,aAAA;AAijCJ;;AA7iCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAgjCF;AA9iCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAgjCJ;AA7iCE;EACE,eAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA+iCJ;AA5iCE;EACE,sCAAA;AA8iCJ;AA3iCE;EACE,oCAAA;EACA,sCAAA;EACA,WAAA;AA6iCJ;AA3iCI;EACE,qCAAA;AA6iCN;;AAxiCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA2iCF;AAziCE;EACE,cAAA;AA2iCJ;AAxiCE;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA0iCJ;AAxiCI;EACE,aAAA;EACA,sCAAA;EACA,6CAAA;AA0iCN;AAtiCE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAwiCJ;AAtiCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAwiCN;;AAniCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAsiCF;;AAniCA;EACE;IACE,gBAAA;EAsiCF;EAniCA;IACE,gBAAA;IACA,eAAA;EAqiCF;AACF;AAliCA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAoiCF;;AAjiCA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mDAAA;EACA,sBAAA;AAoiCF;;AAjiCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAoiCF;AAliCE;EACE,cAAA;EACA,cAAA;AAoiCJ;AAjiCE;EACE,OAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAmiCJ;AAhiCE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AAkiCJ;;AA9hCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAiiCF;;AA9hCA;EACE,aAAA;EACA,QAAA;AAiiCF;;AA9hCA;EACE,aAAA;EACA,mFAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAiiCF;;AA9hCA;EACE,qBAAA;EACA,mBAAA;AAiiCF;;AA9hCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAiiCF;;AA9hCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAiiCF;;AA9hCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAiiCF;;AA9hCA;EACE,aAAA;EACA,YAAA;AAiiCF;AA/hCE;;EAEE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiiCJ;;AA7hCA;EACE,aAAA;EACA,QAAA;EACA,oBAAA;AAgiCF;;AA7hCA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mDAAA;AAgiCF;;AA7hCA;EACE,mBAAA;EACA,cAAA;AAgiCF;;AA7hCA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAgiCF;AA9hCE;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAgiCJ;AA7hCE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AA+hCJ;;AA3hCA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AA8hCF;;AA3hCA;EACE;IACE,0BAAA;EA8hCF;AACF;AA3hCA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;AA6hCF;;AA1hCA;EACE,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;AA6hCF;;AAzhCE;EACE,4BAAA;AA4hCJ;AAzhCE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA2hCJ;AAxhCE;EACE,cAAA;AA0hCJ;AAxhCI;EACE,uBAAA;EACA,cAAA;AA0hCN;AAvhCI;EACE,mDAAA;EACA,uBAAA;AAyhCN;AAvhCM;EACE,oCAAA;AAyhCR;AAphCE;EACE,mBAAA;EACA,cAAA;AAshCJ;AAnhCE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAqhCJ;AAlhCE;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AAohCJ;AAjhCE;EACE,qDAAA;AAmhCJ;AAhhCE;EACE,oCAAA;EACA,cAAA;AAkhCJ;AA/gCE;EACE,qBAAA;EACA,cAAA;AAihCJ;AA9gCE;;EAEE,mBAAA;EACA,qBAAA;EACA,cAAA;AAghCJ;AA7gCE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA+gCJ;AA5gCE;EACE,oCAAA;EACA,sCAAA;AA8gCJ;AA3gCE;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AA6gCJ;AA1gCE;;EAEE,oCAAA;EACA,cAAA;AA4gCJ;AAzgCE;EACE,mCAAA;EACA,cAAA;AA2gCJ","sourcesContent":["@import \"../../shared/styles/org-ui\";\n\n/* Section tabs: one scrollable line with prev/next arrows, matching the org setup wizard */\n.org-tabs-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 16px 0 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--org-border-soft, #e6e6e6);\n}\n\n.org-tabs-arrow {\n  flex: 0 0 auto;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease;\n\n  mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n    line-height: 22px;\n  }\n\n  &:hover:not(:disabled) {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    color: var(--org-primary, var(--fc-brand, #5ea1d8));\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-tabs-nav .org-tabs {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 4px 2px;\n  border-bottom: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  touch-action: pan-x;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.org-tabs-nav .org-tab {\n  flex: 0 0 auto;\n  border: none;\n  background: transparent;\n  padding: 0;\n  min-height: 0;\n  color: #9ca3af;\n  white-space: nowrap;\n  touch-action: pan-x;\n\n  &:hover {\n    background: transparent;\n    color: #6b7280;\n  }\n\n  .org-tab__label {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    line-height: 1.2;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    padding: 7px 14px;\n    border-radius: 35px;\n    border: 2px solid currentColor;\n  }\n\n  .status-badge {\n    margin-left: 0;\n    text-transform: none;\n    letter-spacing: 0;\n  }\n\n  &.active {\n    color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    background: transparent;\n\n    .org-tab__label {\n      background: rgba(94, 161, 216, 0.1);\n    }\n  }\n}\n\n.org-header-actions .org-btn mat-icon {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n\n@media (max-width: 640px) {\n  /* Primary action on its own row; secondary actions share the row below. */\n  .org-header-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px;\n    margin: 4px 0 8px;\n\n    .org-btn {\n      width: 100%;\n      min-height: 44px;\n      padding: 8px 10px;\n      font-size: 14px;\n      white-space: normal;\n      text-align: center;\n      line-height: 1.2;\n    }\n\n    .org-btn-primary,\n    a.org-btn:only-of-type {\n      grid-column: 1 / -1;\n    }\n  }\n\n  .org-tabs-nav {\n    gap: 4px;\n  }\n\n  .org-tabs-arrow {\n    width: 28px;\n    height: 28px;\n  }\n\n  .org-tabs-nav .org-tab .org-tab__label {\n    font-size: 11px;\n    letter-spacing: 0.02em;\n    padding: 6px 12px;\n  }\n}\n\n.org-selector {\n  margin: 12px 0 4px;\n}\n\n.owned-list {\n  display: grid;\n  gap: 8px;\n}\n\n.owned-item {\n  padding: 10px 12px;\n  background: #f7f8fa;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  color: #1a1a1a;\n}\n\n.library-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.library-card {\n  display: grid;\n  gap: 8px;\n  text-align: left;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  background: #fff;\n  padding: 0;\n  overflow: hidden;\n  cursor: pointer;\n  font: inherit;\n  color: #1a1a1a;\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.library-card:hover {\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.library-card__thumb {\n  height: 96px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #eef5fb, #f7faf8);\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n  overflow: hidden;\n  position: relative;\n}\n\n.library-card__cover {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.library-card__thumb mat-icon {\n  font-size: 36px;\n  width: 36px;\n  height: 36px;\n}\n\n.library-card__body {\n  padding: 10px 12px 14px;\n  display: grid;\n  gap: 4px;\n}\n\n.library-card__type {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--org-accent, var(--fc-brand, #5ea1d8));\n}\n\n.library-card__uid {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #1d67a3;\n  background: #e3f2fd;\n  padding: 2px 8px;\n  border-radius: 4px;\n  justify-self: start;\n  letter-spacing: 0.02em;\n}\n\n.feedback-card {\n  padding: 12px 14px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  background: #fff;\n  color: #1a1a1a;\n  display: grid;\n  gap: 6px;\n}\n\n.feedback-card__top {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.issue-chip {\n  display: inline-flex;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.15);\n  color: #1a5278;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.access-role-list {\n  margin-bottom: 16px;\n}\n\n.audit-section {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.audit-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 12px 0 16px;\n  min-width: 0;\n}\n\n.audit-filters {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  max-width: 100%;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.audit-filter {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  padding: 6px 12px;\n  border-radius: 999px;\n  border: 1px solid #d0d7de;\n  background: transparent;\n  color: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n\n  .count {\n    min-width: 18px;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: rgba(94, 161, 216, 0.12);\n    font-size: 11px;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  &:hover {\n    border-color: var(--fc-brand, #5ea1d8);\n  }\n\n  &.active {\n    background: var(--fc-brand, #5ea1d8);\n    border-color: var(--fc-brand, #5ea1d8);\n    color: #fff;\n\n    .count {\n      background: rgba(255, 255, 255, 0.25);\n    }\n  }\n}\n\n.audit-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 280px;\n  min-width: 0;\n  max-width: 460px;\n\n  > mat-icon {\n    color: #667085;\n  }\n\n  input {\n    flex: 1 1 auto;\n    min-width: 0;\n    height: 40px;\n    box-sizing: border-box;\n    padding: 0 12px;\n    border: 1px solid #d0d7de;\n    border-radius: 8px;\n    background: #fff;\n    color: inherit;\n    font-size: 14px;\n\n    &:focus {\n      outline: none;\n      border-color: var(--fc-brand, #5ea1d8);\n      box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n    }\n  }\n\n  .org-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    height: 40px;\n    min-height: 40px;\n    padding: 0 14px;\n    flex-shrink: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n}\n\n.audit-state {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 24px 0;\n  color: #667085;\n}\n\n@media (max-width: 600px) {\n  .audit-filters {\n    flex-basis: 100%;\n  }\n\n  .audit-search {\n    flex-basis: 100%;\n    max-width: none;\n  }\n}\n\n.members-panel__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.members-panel__count {\n  display: inline-block;\n  margin-left: 6px;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  background: #eef5fb;\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n  vertical-align: middle;\n}\n\n.members-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1 1 260px;\n  max-width: 360px;\n\n  > mat-icon {\n    color: #667085;\n    flex-shrink: 0;\n  }\n\n  input {\n    flex: 1;\n    min-width: 0;\n    height: 40px;\n    box-sizing: border-box;\n    padding: 0 12px;\n    border: 1px solid #d9dee5;\n    border-radius: 8px;\n    font: inherit;\n  }\n\n  .org-btn {\n    height: 40px;\n    min-height: 40px;\n    width: 40px;\n    padding: 0;\n    flex-shrink: 0;\n  }\n}\n\n.members-alert {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #fff7e6;\n  border: 1px solid #ffd591;\n  color: #8a5300;\n  font-size: 0.875rem;\n}\n\n.members-table {\n  display: grid;\n  gap: 8px;\n}\n\n.members-row {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.2fr) minmax(160px, 1fr) minmax(240px, 1.4fr);\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  background: #fff;\n}\n\n.members-row--unassigned {\n  border-color: #ffd591;\n  background: #fffbf2;\n}\n\n.members-row__who {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.members-row__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.members-row__avatar-icon {\n  font-size: 32px;\n  width: 32px;\n  height: 32px;\n  color: #9aa5b1;\n}\n\n.members-row__text {\n  display: grid;\n  min-width: 0;\n\n  strong,\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.members-row__scope {\n  display: grid;\n  gap: 4px;\n  justify-items: start;\n}\n\n.role-chip {\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background: #eef5fb;\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n}\n\n.role-chip--none {\n  background: #fff1e0;\n  color: #b45309;\n}\n\n.members-row__edit {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n\n  .org-input {\n    flex: 1 1 140px;\n    min-width: 120px;\n    height: 40px;\n    min-height: 40px;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .org-btn {\n    height: 40px;\n    min-height: 40px;\n    padding: 0 16px;\n  }\n}\n\n.members-pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n@media (max-width: 860px) {\n  .members-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.invite-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(15, 23, 42, 0.55);\n}\n\n.invite-dialog {\n  width: 100%;\n  max-width: 560px;\n  max-height: calc(100vh - 32px);\n  overflow-y: auto;\n  margin: 0;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);\n}\n\n:host-context(body.theme-dark) {\n  .org-tabs-nav {\n    border-bottom-color: #334155;\n  }\n\n  .org-tabs-arrow {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e2e8f0;\n  }\n\n  .org-tabs-nav .org-tab {\n    color: #64748b;\n\n    &:hover {\n      background: transparent;\n      color: #94a3b8;\n    }\n\n    &.active {\n      color: var(--org-primary, var(--fc-brand, #5ea1d8));\n      background: transparent;\n\n      .org-tab__label {\n        background: rgba(94, 161, 216, 0.15);\n      }\n    }\n  }\n\n  .invite-dialog {\n    background: #0f172a;\n    color: #e5e7eb;\n  }\n\n  .owned-item {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .library-card,\n  .feedback-card {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .library-card__thumb {\n    background: linear-gradient(135deg, #1e3a5f, #0f172a);\n  }\n\n  .issue-chip {\n    background: rgba(94, 161, 216, 0.25);\n    color: #bae6fd;\n  }\n\n  .audit-filter {\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .audit-search input,\n  .members-search input {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .members-row {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .members-row--unassigned {\n    background: rgba(245, 158, 11, 0.08);\n    border-color: rgba(245, 158, 11, 0.45);\n  }\n\n  .members-alert {\n    background: rgba(245, 158, 11, 0.12);\n    border-color: rgba(245, 158, 11, 0.45);\n    color: #fcd34d;\n  }\n\n  .role-chip,\n  .members-panel__count {\n    background: rgba(94, 161, 216, 0.25);\n    color: #bae6fd;\n  }\n\n  .role-chip--none {\n    background: rgba(245, 158, 11, 0.2);\n    color: #fcd34d;\n  }\n}\n","/* Shared Organization UI — used by org-onboarding + org-admin + org-join */\n\n:root {\n  --org-border: #d1d5db;\n  --org-border-soft: #e6e6e6;\n  --org-surface: #ffffff;\n  --org-surface-muted: #f7f8fa;\n  --org-muted: #6b7280;\n  --org-text: #1a1a1a;\n  --org-control-height: 48px;\n  --org-control-radius: 8px;\n}\n\n.org-page {\n  max-width: 960px;\n  margin: 24px auto;\n  padding: 0 16px 40px;\n  color: var(--org-text);\n}\n\n.skeleton-org-container {\n  padding: 16px 0 8px;\n}\n\n.org-page__card {\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  background: var(--org-surface);\n  color: inherit;\n}\n\n.org-page__card mat-card-header {\n  margin-bottom: 8px;\n}\n\n.org-page__card mat-card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--org-text);\n}\n\n.org-page__card mat-card-subtitle {\n  color: #555;\n}\n\n.org-header-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 8px 0 4px;\n  align-items: center;\n}\n\n/* Bootstrap (3 via CDN + npm) gives every <label> a bottom margin and bold weight. */\n.org-field,\n.access-role-switch,\n.feature-toggle {\n  margin: 0;\n  max-width: 100%;\n  font-weight: inherit;\n}\n\n.org-field {\n  display: grid;\n  gap: 6px;\n  width: 100%;\n  min-width: 0;\n  align-content: end;\n}\n\n.org-field__label {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #374151;\n}\n\n.org-input {\n  width: 100%;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--org-text);\n  background: var(--org-surface);\n  border: 1px solid var(--org-border);\n  border-radius: var(--org-control-radius);\n  padding: 12px 14px;\n  margin: 0;\n  min-height: var(--org-control-height);\n  line-height: 1.4;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n\n  &::placeholder {\n    color: var(--org-muted);\n    opacity: 1;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n  }\n\n  &:disabled {\n    opacity: 0.65;\n    cursor: not-allowed;\n    background: #f9fafb;\n  }\n}\n\ntextarea.org-input {\n  min-height: 96px;\n  resize: vertical;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\ninput[type=\"file\"].org-input {\n  height: var(--org-control-height);\n  min-height: var(--org-control-height);\n  padding: 8px 12px;\n  line-height: 30px;\n  cursor: pointer;\n\n  &::file-selector-button {\n    height: 30px;\n    margin: 0 10px 0 0;\n    padding: 0 12px;\n    border: 1px solid var(--org-border);\n    border-radius: 6px;\n    background: var(--org-surface-muted);\n    color: inherit;\n    font: inherit;\n    font-size: 13px;\n    cursor: pointer;\n    vertical-align: middle;\n  }\n}\n\nselect.org-input,\ninput.org-input:not([type=\"file\"]) {\n  height: var(--org-control-height);\n}\n\nselect.org-input {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%236b7280' d='M1 1l5 5 5-5'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n  padding-right: 36px;\n}\n\n.org-btn {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  font-family: inherit;\n  white-space: nowrap;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n  text-decoration: none;\n  text-transform: none;\n  letter-spacing: 0;\n  min-height: var(--org-control-height);\n  border-radius: var(--org-control-radius);\n  font-size: 14px;\n  font-weight: 500;\n  padding: 12px 20px;\n  line-height: 1.2;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.org-btn-primary {\n  border: none;\n  background: var(--org-primary, var(--fc-brand, #5ea1d8));\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #4a8fc4;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-ghost {\n  border: 1px solid #d1d5db;\n  background: var(--org-surface-muted);\n  color: #1f2937;\n\n  &:hover:not(:disabled) {\n    background: #e8edf5;\n    border-color: #c5cdd8;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-text {\n  border: 1px solid var(--org-primary, var(--fc-brand, #5ea1d8));\n  background: transparent;\n  color: var(--org-primary, var(--fc-brand, #5ea1d8));\n\n  &:hover:not(:disabled) {\n    background: rgba(94, 161, 216, 0.08);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-dashed {\n  width: auto;\n  border: 1px dashed var(--org-primary, var(--fc-brand, #5ea1d8));\n  background: var(--org-surface-muted);\n  color: #1f2937;\n\n  &:hover:not(:disabled) {\n    background: #e8edf5;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.org-btn-dashed--block {\n  width: 100%;\n}\n\n.org-btn-remove {\n  border: none;\n  background: transparent;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #c62828;\n  min-height: auto;\n  border-radius: 6px;\n\n  &:hover:not(:disabled) {\n    background: rgba(198, 40, 40, 0.08);\n  }\n}\n\n.org-btn-warn {\n  border: none;\n  background: #c62828;\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    background: #b71c1c;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.manage-app,\n.nested-card {\n  border: 1px solid var(--org-border-soft);\n  border-radius: 10px;\n  padding: 14px;\n  background: var(--org-surface-muted);\n  display: grid;\n  gap: 10px;\n  color: var(--org-text);\n}\n\n.manage-app__header,\n.manage-team__header,\n.nested-card__title {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.manage-app__title,\n.manage-team__title,\n.nested-card__title h3,\n.nested-card__title h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--org-text);\n}\n\n.manage-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Footer action bar for a form block: secondary first, primary last, right-aligned */\n.org-form-actions {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.org-form-actions--split {\n  justify-content: space-between;\n}\n\n.org-form-actions__group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.manage-app__header > .org-btn,\n.manage-app__header .manage-actions .org-btn,\n.manage-team__header .manage-actions .org-btn,\n.nested-card__title > .org-btn {\n  height: 36px;\n  min-height: 36px;\n  padding: 0 14px;\n  font-size: 13px;\n}\n\n.org-section > .org-btn,\n.org-form-panel > .org-btn,\n.manage-app > .org-btn:not(.org-btn-dashed--block) {\n  justify-self: start;\n}\n\n.manage-team,\n.team-block {\n  margin-left: 4px;\n  padding: 10px 12px;\n  border-left: 3px solid var(--org-accent, var(--fc-brand, #5ea1d8));\n  background: #fff;\n  border-radius: 0 8px 8px 0;\n  display: grid;\n  gap: 8px;\n  color: var(--org-text);\n}\n\n.edit-grid,\n.form-grid,\n.terminology-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px 12px;\n  align-items: end;\n}\n\n.edit-grid--inset {\n  margin-top: 8px;\n}\n\n.edit-grid--grow {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 14px;\n  align-items: flex-end;\n  padding: 14px 16px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 12px;\n  background: var(--org-surface);\n  color: var(--org-text);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.invite-row .edit-grid {\n  flex: 1;\n  min-width: 0;\n}\n\n.invite-row > .org-btn {\n  flex-shrink: 0;\n}\n\n.invite-list {\n  display: grid;\n  gap: 10px;\n}\n\n.invite-card {\n  display: grid;\n  gap: 12px;\n  padding: 16px 18px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 14px;\n  background: var(--org-surface);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);\n  color: var(--org-text);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.invite-card:hover {\n  border-color: rgba(94, 161, 216, 0.45);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n}\n\n.invite-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.invite-card__identity {\n  display: grid;\n  gap: 6px;\n  min-width: 0;\n}\n\n.invite-card__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 650;\n  color: var(--org-text);\n  word-break: break-word;\n}\n\n.invite-card__subtitle {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--org-muted);\n  line-height: 1.4;\n}\n\n.invite-card__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.invite-meta-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: var(--org-surface-muted);\n  border: 1px solid var(--org-border-soft);\n  color: #374151;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.invite-card__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-shrink: 0;\n}\n\n.invite-card__body {\n  display: grid;\n  gap: 10px;\n  padding-top: 4px;\n  border-top: 1px solid var(--org-border-soft);\n}\n\n.invite-card--join .invite-card__body {\n  margin-top: 2px;\n}\n\n.invite-card__footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n  padding-top: 4px;\n}\n\n.org-form-panel {\n  display: grid;\n  gap: 14px;\n  padding: 18px;\n  border: 1px solid var(--org-border-soft);\n  border-radius: 14px;\n  background: linear-gradient(\n    180deg,\n    var(--org-surface) 0%,\n    var(--org-surface-muted) 100%\n  );\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);\n}\n\n.org-form-panel__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 650;\n}\n\n.org-form-panel__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.org-form-panel__hint {\n  margin: -6px 0 0;\n  font-size: 0.85rem;\n  color: var(--org-muted);\n}\n\n.org-section-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px 12px;\n  margin-top: 8px;\n}\n\n.org-section-head h2 {\n  margin: 0;\n}\n\n.org-section-head__count {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--org-muted);\n}\n\n/* Status badges — Pending / Requested / Accepted / Rejected */\n.status-badge,\n.pending-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.2;\n  white-space: nowrap;\n  border: 1px solid transparent;\n  vertical-align: middle;\n}\n\n.status-badge mat-icon,\n.pending-badge mat-icon {\n  font-size: 14px;\n  width: 14px;\n  height: 14px;\n}\n\n.status-badge--pending,\n.pending-badge {\n  background: rgba(242, 169, 0, 0.16);\n  color: #8a5a00;\n  border-color: rgba(242, 169, 0, 0.28);\n  margin-left: 0;\n}\n\n.status-badge--requested {\n  background: rgba(94, 161, 216, 0.14);\n  color: #0b3d5c;\n  border-color: rgba(94, 161, 216, 0.3);\n}\n\n.status-badge--accepted {\n  background: rgba(22, 163, 74, 0.12);\n  color: #166534;\n  border-color: rgba(22, 163, 74, 0.28);\n}\n\n.status-badge--rejected {\n  background: rgba(198, 40, 40, 0.1);\n  color: #991b1b;\n  border-color: rgba(198, 40, 40, 0.22);\n}\n\n.status-badge--incoming {\n  background: rgba(124, 58, 237, 0.1);\n  color: #5b21b6;\n  border-color: rgba(124, 58, 237, 0.22);\n}\n\n.muted,\n.hint {\n  color: #555;\n  font-size: 0.875rem;\n  margin: 0;\n}\n\n.muted-empty {\n  margin: 0;\n  color: #777;\n  font-size: 0.85rem;\n  padding: 18px 16px;\n  text-align: center;\n  border: 1px dashed var(--org-border-soft);\n  border-radius: 12px;\n  background: var(--org-surface-muted);\n}\n\n.term-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.term-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 10px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.18);\n  color: #1a5278;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.term-chip__remove {\n  border: none;\n  background: transparent;\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: inherit;\n  font-size: 16px;\n  line-height: 1;\n}\n\n.term-add-row,\n.org-inline-row {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: end;\n}\n\n.term-add-row .org-btn,\n.org-inline-row .org-btn {\n  align-self: end;\n}\n\n.library-access-panel {\n  display: grid;\n  gap: 6px;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 40px 16px;\n  color: #555;\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n}\n\n.empty-state mat-icon {\n  font-size: 48px;\n  width: 48px;\n  height: 48px;\n  color: var(--fc-brand, #5ea1d8);\n}\n\n.org-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 16px 0 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--org-border-soft);\n}\n\n.org-tab {\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #555;\n  cursor: pointer;\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n\n  &:hover {\n    background: #f5f5f5;\n  }\n\n  &.active {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    background: rgba(94, 161, 216, 0.12);\n    color: #0b3d5c;\n  }\n\n  .status-badge,\n  .pending-badge {\n    margin-left: 6px;\n  }\n}\n\n.org-section {\n  display: grid;\n  gap: 12px;\n}\n\n.org-section h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--org-text);\n}\n\n.editing-banner {\n  margin: 0 0 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: rgba(94, 161, 216, 0.12);\n  color: #1a5278;\n  font-size: 0.9rem;\n}\n\n/* Access roles — shared by onboarding + admin */\n.access-role-list {\n  display: grid;\n  gap: 12px;\n}\n\n.access-role-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.access-role-card--off {\n  opacity: 0.72;\n  background: #fafafa;\n}\n\n.access-role-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-bottom: 1px solid #eee;\n  background: #f8fafc;\n}\n\n.access-role-card__toggle-expand {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--org-text);\n  padding: 0;\n}\n\n.access-role-card__key {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.9rem;\n}\n\n.access-role-switch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #334155;\n  user-select: none;\n}\n\n.access-role-switch input,\n.feature-toggle input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.feature-toggle input[type=\"checkbox\"] {\n  margin-top: 2px;\n}\n\n.access-role-switch.locked {\n  opacity: 0.85;\n}\n\n.access-role-card__body {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n}\n\n.access-role-features-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.feature-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: rgba(94, 161, 216, 0.15);\n  color: #0b3d5c;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.access-role-features__title {\n  margin: 4px 0 0;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.feature-toggle {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 8px 0;\n  border-top: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n\n.feature-toggle__text {\n  display: grid;\n  gap: 2px;\n}\n\n.feature-toggle__text strong {\n  font-size: 0.9rem;\n}\n\n.feature-toggle__text small {\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 640px) {\n  .org-page {\n    margin-top: 12px;\n    padding: 0 12px 32px;\n  }\n\n  .invite-row,\n  .invite-card,\n  .manage-app__header,\n  .manage-team__header,\n  .nested-card__title {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invite-card__top,\n  .invite-card__footer,\n  .invite-card__actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invite-card__actions .org-btn,\n  .invite-card__footer .org-btn {\n    width: 100%;\n  }\n\n  .term-add-row,\n  .org-inline-row {\n    grid-template-columns: 1fr;\n  }\n\n  .term-add-row .org-btn,\n  .org-inline-row .org-btn {\n    width: 100%;\n  }\n\n  .manage-actions .org-btn,\n  .org-form-actions .org-btn,\n  .org-form-panel__actions .org-btn {\n    flex: 1 1 auto;\n  }\n\n  .org-form-actions,\n  .org-form-actions__group {\n    width: 100%;\n  }\n\n  .invite-row .org-btn {\n    width: 100%;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .org-page {\n    color: #e5e7eb;\n  }\n\n  .org-page__card {\n    background: #1e293b;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.35);\n    color: #e5e7eb;\n  }\n\n  .org-page__card mat-card-title,\n  .org-section h2,\n  .manage-app__title,\n  .manage-team__title,\n  .nested-card__title h3,\n  .nested-card__title h4 {\n    color: #f8fafc;\n  }\n\n  .org-page__card mat-card-subtitle,\n  .muted,\n  .hint,\n  .muted-empty,\n  .empty-state {\n    color: #94a3b8;\n  }\n\n  .org-field__label {\n    color: #cbd5e1;\n  }\n\n  .org-input {\n    color: #f8fafc;\n    background: #0f172a;\n    border-color: #475569;\n\n    &::placeholder {\n      color: #94a3b8;\n    }\n\n    &:focus {\n      border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n      box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.25);\n    }\n\n    &:disabled {\n      background: #1e293b;\n    }\n  }\n\n  .org-btn-ghost {\n    border-color: #334155;\n    background: #0f172a;\n    color: #e5e7eb;\n\n    &:hover:not(:disabled) {\n      background: #334155;\n    }\n  }\n\n  .org-btn-text {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    color: #7eb8e8;\n\n    &:hover:not(:disabled) {\n      background: rgba(94, 161, 216, 0.15);\n    }\n  }\n\n  .org-btn-dashed {\n    border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n    background: #0f172a;\n    color: #e5e7eb;\n\n    &:hover:not(:disabled) {\n      background: #1e293b;\n    }\n  }\n\n  .org-btn-remove {\n    color: #f87171;\n\n    &:hover:not(:disabled) {\n      background: rgba(248, 113, 113, 0.12);\n    }\n  }\n\n  .manage-app,\n  .nested-card,\n  .invite-row,\n  .invite-card,\n  .org-form-panel {\n    background: #0f172a;\n    border-color: #334155;\n    color: #e5e7eb;\n  }\n\n  .invite-card:hover {\n    border-color: rgba(94, 161, 216, 0.5);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n  }\n\n  .invite-card__title {\n    color: #f8fafc;\n  }\n\n  .invite-card__subtitle,\n  .org-form-panel__hint,\n  .org-section-head__count {\n    color: #94a3b8;\n  }\n\n  .invite-card__body {\n    border-top-color: #334155;\n  }\n\n  .invite-meta-chip {\n    background: #1e293b;\n    border-color: #334155;\n    color: #cbd5e1;\n  }\n\n  .muted-empty {\n    background: #0f172a;\n    border-color: #334155;\n    color: #94a3b8;\n  }\n\n  .manage-team,\n  .team-block {\n    background: #1e293b;\n    color: #e5e7eb;\n  }\n\n  .org-tabs {\n    border-bottom-color: #334155;\n  }\n\n  .org-tab {\n    color: #94a3b8;\n\n    &:hover {\n      background: #0f172a;\n    }\n\n    &.active {\n      border-color: var(--org-primary, var(--fc-brand, #5ea1d8));\n      background: rgba(94, 161, 216, 0.2);\n      color: #e0f2fe;\n    }\n  }\n\n  .pending-badge,\n  .status-badge--pending {\n    background: rgba(242, 169, 0, 0.25);\n    color: #fbbf24;\n    border-color: rgba(242, 169, 0, 0.35);\n  }\n\n  .status-badge--requested {\n    background: rgba(94, 161, 216, 0.22);\n    color: #7dd3fc;\n    border-color: rgba(94, 161, 216, 0.35);\n  }\n\n  .status-badge--accepted {\n    background: rgba(34, 197, 94, 0.18);\n    color: #86efac;\n    border-color: rgba(34, 197, 94, 0.3);\n  }\n\n  .status-badge--rejected {\n    background: rgba(248, 113, 113, 0.15);\n    color: #fca5a5;\n    border-color: rgba(248, 113, 113, 0.28);\n  }\n\n  .status-badge--incoming {\n    background: rgba(167, 139, 250, 0.18);\n    color: #c4b5fd;\n    border-color: rgba(167, 139, 250, 0.3);\n  }\n\n  .term-chip {\n    background: rgba(94, 161, 216, 0.25);\n    color: #bae6fd;\n  }\n\n  .editing-banner {\n    background: rgba(94, 161, 216, 0.2);\n    color: #bae6fd;\n  }\n\n  .empty-state mat-icon {\n    color: var(--fc-brand, #5ea1d8);\n  }\n\n  .access-role-card {\n    background: #0f172a;\n    border-color: #334155;\n  }\n\n  .access-role-card--off {\n    background: #0b1220;\n  }\n\n  .access-role-card__header {\n    background: #111827;\n    border-color: #334155;\n  }\n\n  .access-role-card__toggle-expand,\n  .access-role-switch,\n  .access-role-features__title {\n    color: #e2e8f0;\n  }\n\n  .feature-chip {\n    background: rgba(94, 161, 216, 0.22);\n    color: #bae6fd;\n  }\n\n  .feature-toggle {\n    border-color: #1e293b;\n  }\n\n  .feature-toggle__text small {\n    color: #94a3b8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
